import { configureStore } from "@reduxjs/toolkit";
import userSlice from "../storeSlices/userSlice";
import chalanSlice from "../storeSlices/chalanSlice";
import localChalanSlice from "../storeSlices/localChalanSlice";
import dataSlice from "../storeSlices/dataSlice";
import thunk from "redux-thunk";
import biltySlice from "../storeSlices/biltySlice";
export const store = configureStore({
  reducer: {
    userReducer: userSlice,
    chalanReducer: chalanSlice,
    localChalanReducer: localChalanSlice,
    dataReducer: dataSlice,
    biltyReducer: biltySlice,
  },
  middleware: [thunk],
});
